import type { PortableTextTypeComponent } from '@portabletext/react';

const patterns = [
  /youtu\.be\/([^#&?]{11})/, // youtu.be/<id>
  /\?v=([^#&?]{11})/, // ?v=<id>
  /&v=([^#&?]{11})/, // &v=<id>
  /embed\/([^#&?]{11})/, // embed/<id>
  /\/v\/([^#&?]{11})/, // /v/<id>
];

const extractYoutubeId = (url: string) => {
  if (!url) return null;
  for (const p of patterns) {
    if (p.test(url)) {
      return p.exec(url)?.[1] ?? null;
    }
  }

  return null;
};

interface Props {
  _type: 'youtube';
  url: string;
}

const YoutubeEmbed: PortableTextTypeComponent<Props> = ({
  value: { url = '' } = {},
}) => {
  const videoId = extractYoutubeId(url);
  if (!videoId) {
    return null;
  }

  return (
    <div className="mb-12 w-full px-2 sm:px-20 md:px-32 lg:mb-20 lg:px-40">
      <div className="relative w-full pb-[56.26%]">
        <iframe
          loading="lazy"
          className="absolute size-full"
          src={`https://www.youtube-nocookie.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default YoutubeEmbed;

export const YoutubeEmbedHtml: PortableTextTypeComponent<Props> = ({
  value: { url = '' } = {},
}) => {
  const videoId = extractYoutubeId(url);
  if (!videoId) {
    return null;
  }

  return (
    <div>
      <div>
        <iframe
          loading="lazy"
          src={`https://www.youtube-nocookie.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};
